import { render, staticRenderFns } from "./LinkPaymentOption.vue?vue&type=template&id=2b5a5c92&scoped=true"
import script from "./LinkPaymentOption.vue?vue&type=script&lang=js"
export * from "./LinkPaymentOption.vue?vue&type=script&lang=js"
import style0 from "./LinkPaymentOption.vue?vue&type=style&index=0&id=2b5a5c92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5a5c92",
  null
  
)

export default component.exports